<template>
  <div class="containt" :id="cid">
    <div class="filt-wrapper" :class="{ activeted: isshow }">
      <div class="filt-bar">
        <div class="main-title">{{KDApi.getLangMsg(this.model, 'title.initplan')}}</div>
        <div
          class="desc-title"
          v-show="
            filtSearch.plantype.length > 0 ||
            filtSearch.startdate.length > 0 ||
            filtSearch.enddate.length > 0 ||
            filtSearch.planstatus.length > 0
          "
        >
          <!-- 筛选条件 -->
          {{KDApi.getLangMsg(this.model, 'filt.filterconditions')}}
        </div>
        <div class="filt-status">
          <div class="filt-item" v-show="filtSearch.plantype.length > 0">
            <!-- 初始化场景： -->
            {{KDApi.getLangMsg(this.model, 'filt.initscene')}}：
            <span v-for="(item, index) in filtSearch.plantype" :key="item">
              <span v-if="index !== 0">,</span>
              {{ sceneListObj[item] }}
            </span>
          </div>
          <div class="filt-item" v-show="filtSearch.startdate.length > 0">
            <!-- 计划开始日期：{{ filtSearch.startdate[0] }} -->
            {{ KDApi.getLangMsg(this.model, 'col.startdate') + "：" + filtSearch.startdate[0] }}
          </div>
          <div class="filt-item" v-show="filtSearch.enddate.length > 0">
            <!-- 计划结束日期：{{ filtSearch.enddate[0] }} -->
            {{ KDApi.getLangMsg(this.model, 'col.enddate') + "：" + filtSearch.enddate[0] }}
          </div>
          <div class="filt-item" v-show="filtSearch.planstatus.length > 0">
            {{ KDApi.getLangMsg(this.model, 'col.status') + "："}}<span
              v-for="(item, index) in filtSearch.planstatus"
              :key="item"
            >
              <span v-if="index !== 0">,</span>
              {{ planstatusObj[item] }}
            </span>
            <i
              class="kdfont kdfont-shanchu-s secondary-text-in-light"
              @click="resetPlanstatus"
            ></i>
          </div>
        </div>
        <div class="search-box">
          <!-- <el-input
            @change="searchBoxChange"
            placeholder="请搜索计划编号/计划名称"
            prefix-icon="el-icon-search"
            v-model="searchVal"
          ></el-input> -->
          <i class="kdfont kdfont-f input-color"></i>
          <input
            type="text"
            v-model="searchVal"
            @change="searchBoxChange"
            :placeholder="KDApi.getLangMsg(this.model, 'placeholder.inputtips')"
          />
        </div>
        <div class="togle-btn" @click="isshow = !isshow">
          <!-- {{ isshow ? "收起过滤" : "展开过滤" }} -->
          {{ isshow ? KDApi.getLangMsg(this.model, 'btn.collapse') : KDApi.getLangMsg(this.model, 'btn.expand') }}
          <div class="kdfont kdfont-xiala"></div>
        </div>
      </div>
      <transition name="fade">
        <div class="filt-board" v-show="isshow">
          <div class="board-title">
            <!-- 常用条件 -->
            {{KDApi.getLangMsg(this.model, 'filt.commonconditions')}}
          </div>
          <ul class="filt-list">
            <!-- <li class="filt-item">
              <i-filt-item
                :title="'初始化场景'"
                @handleSelected="hdScene"
                :selectItemList="sceneList"
              />
            </li> -->
            <!-- <li class="filt-item">
                            <i-filt-item
                                :title="'业务领域范围'"
                                @handleSelected="hdBus"
                                :selectItemList="busList"
                            />
                        </li>
                        <li class="filt-item">
                            <i-filt-item
                                :title="'业务子领域范围'"
                                @handleSelected="hdCBus"
                                :selectItemList="childBusList"
                            />
                        </li> -->
            <li class="filt-item">
              <i-date-filt :title="KDApi.getLangMsg(this.model, 'col.startdate')" @handleSelected="hdSTime" />
            </li>
            <li class="filt-item">
              <i-date-filt :title="KDApi.getLangMsg(this.model, 'col.enddate')" @handleSelected="hdETime" />
            </li>
            <li class="filt-item">
              <i-filt-item
                :title="KDApi.getLangMsg(this.model, 'col.status')"
                @handleSelected="hdStatus"
                :selectItemList="planstatus"
                ref="planstatusRef"
              />
            </li>
          </ul>
        </div>
      </transition>
      <div class="tool-bar">
        <a class="down i-btn sure">
          <!-- 新增 -->
          <span class="main-span" @click="optable('newAdd')">{{KDApi.getLangMsg(this.model, "btn.add")}}</span>
          <span
            class="down-icon kdfont kdfont-xiala"
            :class="{ activeted: isOpen }"
            @click="isOpen = !isOpen"
          ></span>
          <transition name="fade">
            <ul class="down-list" v-show="isOpen">
              <!-- 复制 -->
              <li class="down-list-item" @click="optable('copy')">{{KDApi.getLangMsg(this.model, "btn.copy")}}</li>
            </ul>
          </transition>
        </a>

        <!-- 删除 -->
        <div class="i-btn sure" @click="optable('delete')">{{KDApi.getLangMsg(this.model, "btn.del")}}</div>
        <!-- 查看全部日志 -->
        <div class="i-btn sure view-log" @click="optable('viewLog')">
          {{KDApi.getLangMsg(this.model, "btn.viewlogs")}}
        </div>
        <!-- 刷新 -->
        <div class="i-btn sure" @click="optable('refresh')">{{KDApi.getLangMsg(this.model, "btn.refresh")}}</div>
        <!-- 退出 -->
        <div class="i-btn sure" @click="optable('close')">{{KDApi.getLangMsg(this.model, "btn.exit")}}</div>
      </div>
    </div>
    <div class="table-box">
      <div class="tips-bar">
        <div class="select-status">
          <div class="slect-ed" v-if="model.lang === 'zh_CN'">
            <!-- 已选{{ selected.length }}条数,共{{ mateTableData.length }}条 -->
            {{KDApi.getLangMsg(this.model, "tips.selected") + selected.length + KDApi.getLangMsg(this.model, "tips.rows")}},
            {{KDApi.getLangMsg(this.model, "tips.total") + mateTableData.length + KDApi.getLangMsg(this.model, "tips.items")}}
          </div>
          <div class="slect-ed" v-else>
            {{KDApi.getLangMsg(this.model, "tips.selected") + " " + selected.length + " " + KDApi.getLangMsg(this.model, "tips.rows")}},
            {{KDApi.getLangMsg(this.model, "tips.total") + " " + mateTableData.length + " " + KDApi.getLangMsg(this.model, "tips.items")}}
          </div>
          <div class="page-box">
            <Page
              :total="total"
              :pageRange="pageRange"
              @pageChange="pageChange"
            />
          </div>
        </div>
      </div>
      <div class="tg_table">
        <el-table
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :default-expand-all="false"
          :tree-props="{ children: 'children' }"
          header-row-class-name="tg-tbale-head"
          :header-cell-style="{ background: '#f4f4f4' }"
          ref="multipleTable"
          row-key="id"
          lazy
          highlight-current-row
          @selection-change="handleSelectionChange"
          :border="true"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            prop="number"
            :label="KDApi.getLangMsg(this.model, 'col.number')"
            v-if="headList.number"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.name')"
            v-if="headList.name"
            min-width="180"
            show-overflow-tooltip
          >
            <template #default="scope">
              <a class="golink_tag" @click="linkDetail(scope.row)">
                {{ scope.row.name && (scope.row.name[model.lang] || scope.row.name["zh_CN"])}}
              </a>
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.parentcode')"
            v-if="headList.parent"
            show-overflow-tooltip
            min-width="120"
          >
            <template #default="scope">
              {{
                scope.row.parent &&
                scope.row.parentCode &&
                `${scope.row.parentCode}/${scope.row.parent[model.lang] || scope.row.parent['zh_CN'] || scope.row.parent['GLang']}`
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="初始化场景"
            v-if="headList.plantype"
            show-overflow-tooltip
            width="120"
          >
            <template #default="scope">
              {{ scenceMap[scope.row.plantype] || "" }}
            </template>
          </el-table-column> -->
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.businessscope')"
            v-if="headList.group"
            show-overflow-tooltip
            :min-width="model.lang === 'zh_CN' ? 120 : 140"
          >
            <template #default="scope">
              <span v-for="(cg, index) in scope.row.group" :key="'cg' + index">
                {{ cg[lang] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="bizsubarea"
            :label="KDApi.getLangMsg(this.model, 'col.childbusinessscope')"
            v-if="headList.bizsubarea"
            show-overflow-tooltip
            :min-width="model.lang === 'zh_CN' ? 120 : 190"
          >
            <template #default="scope">
              <span
                v-for="(cg, index) in scope.row.bizsubarea"
                :key="'cg' + index"
              >
                {{ cg[lang] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.startdate')"
            v-if="headList.startdate"
            show-overflow-tooltip
            :min-width="model.lang === 'zh_CN' ? 120 : 150"
          >
            <template #default="scope">
              {{ (scope.row.startdate || "").split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.enddate')"
            v-if="headList.enddate"
            show-overflow-tooltip
            :min-width="model.lang === 'zh_CN' ? 120 : 170"
          >
            <template #default="scope">
              {{ (scope.row.enddate || "").split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.finisheddate')"
            v-if="headList.actualenddate"
            show-overflow-tooltip
            :min-width="model.lang === 'zh_CN' ? 120 : 170"
          >
            <template #default="scope">
              {{ (scope.row.actualenddate || "").split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.chargeperson')"
            v-if="headList.planperson"
            show-overflow-tooltip
            min-width="100"
          >
            <template #default="scope">
              {{ scope.row.planperson && (scope.row.planperson[lang] || scope.row.planperson['zh_CN'] || scope.row.planperson['GLang'])}}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.creator')"
            v-if="headList.creator"
            show-overflow-tooltip
            min-width="100"
          >
            <template #default="scope">
              {{ scope.row.creator && (scope.row.creator[lang] || scope.row.creator['zh_CN'] || scope.row.creator['GLang'])}}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.createdate')"
            v-if="headList.createtime"
            show-overflow-tooltip
            min-width="100"
          >
            <template #default="scope">
              {{ (scope.row.createtime || "").split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column
            min-width="80"
            prop="planstatus"
            :label="KDApi.getLangMsg(this.model, 'col.status')"
            align="center"
            v-if="headList.planstatus"
          >
            <template #default="scope">
              {{ statusMap[scope.row.planstatus] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="KDApi.getLangMsg(this.model, 'col.remark')"
            v-if="headList.datarange"
            min-width="100"
          >
            <template #default="scope">
              {{ scope.row.datarange && (scope.row.datarange[lang] || scope.row.datarange["zh_CN"]) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="50">
            <template slot="header">
              <div class="my-head">
                <el-dropdown trigger="click" :hide-on-click="false">
                  <span class="el-dropdown-link">
                    <i
                      class="
                        kdfont kdfont-shezhi11
                        kd-hover-color
                        hover-theme-hover-fc
                      "
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item>
                      <el-checkbox v-model="headList.number"
                        >计划编号</el-checkbox
                      >
                    </el-dropdown-item> -->
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.name">
                        <!-- 计划名称 -->
                        {{KDApi.getLangMsg(this.model, 'col.name')}}
                      </el-checkbox>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.parent">
                        <!-- 父计划 -->
                        {{KDApi.getLangMsg(this.model, 'col.parentcode')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <!-- <el-dropdown-item>
                      <el-checkbox v-model="headList.plantype"
                        >计划类型</el-checkbox
                      >
                    </el-dropdown-item> -->
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.group">
                        <!-- 业务领域范围 -->
                        {{KDApi.getLangMsg(this.model, 'col.businessscope')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.bizsubarea">
                        <!-- 子业务领域范围 -->
                        {{KDApi.getLangMsg(this.model, 'col.childbusinessscope')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.startdate">
                        <!-- 计划开始日期 -->
                        {{KDApi.getLangMsg(this.model, 'col.startdate')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.enddate">
                        <!-- 计划结束日期 -->
                        {{KDApi.getLangMsg(this.model, 'col.enddate')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.actualenddate">
                        <!-- 实际完成日期 -->
                        {{KDApi.getLangMsg(this.model, 'col.finisheddate')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.planperson">
                        <!-- 计划负责人 -->
                        {{KDApi.getLangMsg(this.model, 'col.chargeperson')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.creator">
                        <!-- 创建人 -->
                        {{KDApi.getLangMsg(this.model, 'col.creator')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.createtime">
                        <!-- 创建时间 -->
                        {{KDApi.getLangMsg(this.model, 'col.createdate')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.planstatus">
                        <!-- 状态 -->
                        {{KDApi.getLangMsg(this.model, 'col.status')}}
                      </el-checkbox >
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="headList.datarange">
                        <!-- 备注 -->
                        {{KDApi.getLangMsg(this.model, 'col.remark')}}
                      </el-checkbox >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template></template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "../../../../util/eventBus";
import IFiltItem from "./i-filt-item.vue";
import IDateFilt from "./i-date-filt.vue";
import Page from "../components/page.vue";

export default {
  inject: ["model", "myInvoke", "KDApi", "containtBoxID"],
  components: {
    IFiltItem,
    IDateFilt,
    Page,
  },
  data() {
    return {
      cid: "containtBoxID",
      isOpen: false,
      mateTableData: [],
      headList: {
        number: true,
        name: true,
        parent: true,
        plantype: true,
        group: true,
        bizsubarea: true,
        startdate: true,
        enddate: true,
        actualenddate: true,
        planperson: true,
        creator: false,
        createtime: false,
        planstatus: true,
        datarange: false,
      },
      selected: [],
      total: 200,
      currPageNum: 1,
      pageRange: 20,
      tableHeight: 220,
      isshow: false,
      sceneList: [
        { name: "全新初始化", val: "A" },
        { name: "增量初始化", val: "B" },
      ],
      sceneListObj: {
        A: "全新初始化",
        B: "增量初始化",
      },
      busList: [
        { name: "基础服务", val: "A" },
        { name: "组织发展", val: "B" },
        { name: "核心人力", val: "C" },
        { name: "人才供应", val: "D" },
      ],
      childBusList: [
        { name: "基础服务", val: 0 },
        { name: "组织管理", val: 1 },
        { name: "职位管理", val: 2 },
        { name: "人才供应", val: 3 },
      ],
      planstatus: [
        { name: KDApi.getLangMsg(this.model, 'filt.tobeconfig'), val: "A" },
        { name: KDApi.getLangMsg(this.model, 'filt.execute'), val: "B" },
        { name: KDApi.getLangMsg(this.model, 'filt.completed'), val: "C" },
        // { name: "已终止", val: "D" },
        // { name: "暂存", val: "E" },
      ],
      planstatusObj: {
        A: KDApi.getLangMsg(this.model, 'filt.tobeconfig'),
        B: KDApi.getLangMsg(this.model, 'filt.execute'),
        C: KDApi.getLangMsg(this.model, 'filt.completed'),
        D: KDApi.getLangMsg(this.model, 'filt.terminated')
      },
      filtVal: {
        plantype: [{ name: "不限", val: "all" }],
        // group: [{ name: "不限", val: "all" }],
        // bizsubarea: [{ name: "不限", val: "all" }],
        startdate: { name: "不限", val: "all" },
        enddate: { name: "不限", val: "all" },
        planstatus: [{ name: "不限", val: "all" }],
      },
      filtSearch: {
        plantype: [], //初始化场景
        startdate: [],
        enddate: [],
        planstatus: [],
        number: "",
        name: "",
      },
      searchVal: "",
      lang: "zh_CN",
      scenceMap: {
        A: "全新初始化",
        B: "增量初始化",
      },
      statusMap: {
        A: KDApi.getLangMsg(this.model, 'filt.tobeconfig'),
        B: KDApi.getLangMsg(this.model, 'filt.execute'),
        C: KDApi.getLangMsg(this.model, 'filt.completed'),
        D: KDApi.getLangMsg(this.model, 'filt.terminated')
      },
      pageParam: {
        num: 1,
        size: 10,
        count: 0,
      },
    };
  },
  created() {
    this.cid = this.containtBoxID;
  },
  mounted() {
    this.initTableListBus = eventBus.sub(
      this.model,
      "initTableList",
      (params) => {
        this.tableHeight = params.height;
        this.mateTableData = params.data.data;
        this.total = params.data.data.length;
        this.lang = params.data.language;
        console.log(this.tableData, "tableData");
      }
    );
  },
  destroyed() {
    eventBus.unsub(this.initTableListBus);
  },
  methods: {
    linkDetail(item) {
      this.myInvoke("planLink", {
        id: item.id,
        planstatus: item.planstatus,
        parentid: item.parentid,
      });
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    //场景
    hdScene(val) {
      console.log("hdScene", val);
      this.filtSearch.plantype = [];
      if (val[0].val === "all") {
      } else {
        val.map((item) => {
          this.filtSearch.plantype.push(item.val);
        });
      }

      this.invokefilt();
    },
    hdBus(val) {
      console.log("hdBus", val);
    },
    hdCBus(val) {
      console.log("hdCBus", val);
    },
    hdSTime(obj) {
      console.log("hdSTime", obj.val);
      this.filtSearch.startdate = this.resolveTime(obj.val);

      this.invokefilt();
    },
    hdETime(obj) {
      console.log("hdETime", obj.val);
      this.filtSearch.enddate = this.resolveTime(obj.val);

      this.invokefilt();
    },
    hdStatus(val) {
      console.log("hdStatus", val);

      this.filtSearch.planstatus = [];
      if (val[0].val === "all") {
      } else {
        val.map((item) => {
          this.filtSearch.planstatus.push(item.val);
        });
      }

      this.invokefilt();
    },
    resetPlanstatus() {
      this.filtSearch.planstatus = [];

      this.$refs.planstatusRef.handleSelectAll();
    },
    optable(type) {
      this.isOpen = false;
      const params = [];
      this.selected.map((item) => {
        params.push({
          id: item.id,
          parentid: item.parentid,
          planstatus: item.planstatus,
          number: item.number,
        });
      });
      console.log("optable:", type, params);
      this.myInvoke(type, params);
    },
    selectAll() {
      console.log("selectAll");
    },
    searchBoxChange() {
      this.filtSearch.name = this.searchVal;
      this.filtSearch.number = this.searchVal;

      this.invokefilt();
    },
    invokefilt() {
      console.log("invokefilt", this.filtSearch);
      this.myInvoke("selectPlan", this.filtSearch);
    },
    resolveTime(type) {
      if (type instanceof Array) {
        return type;
      } else {
        let res = [];
        switch (type) {
          case 0:
            res = [this.gettoday(), this.gettoday()];
            break;
          case 1:
            res = this.last1month();
            break;
          case 2:
            res = this.last3month();
            break;
        }

        return res;
      }
    },
    gettoday() {
      let now = new Date();
      let dateStr =
        now.getFullYear() +
        "-" +
        this.fullzero(now.getMonth() + 1) +
        "-" +
        this.fullzero(now.getDate());
      return dateStr;
    },
    last1month() {
      var end = new Date();
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end =
        year + "-" + this.fullzero(month) + "-" + this.fullzero(day);
      var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.start = year - 1 + "-" + 12 + "-" + this.fullzero(day);
      } else {
        var startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.start =
              year +
              "-" +
              this.fullzero(month - 1) +
              "-" +
              this.fullzero(startMonthDay - (endMonthDay - day));
          } else {
            dateObj.start =
              year +
              "-" +
              this.fullzero(month - 1) +
              "-" +
              this.fullzero(startMonthDay);
          }
        } else {
          dateObj.start =
            year + "-" + this.fullzero(month - 1) + "-" + this.fullzero(day);
        }
      }
      return [dateObj.start, dateObj.end];
    },
    last3month() {
      var end = new Date();
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end =
        year + "-" + this.fullzero(month) + "-" + this.fullzero(day);
      var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 3 <= 0) {
        //如果是1、2、3月，年数往前推一年
        var start3MonthDay = new Date(
          year - 1,
          12 - (3 - parseInt(month)),
          0
        ).getDate(); //3个月前所在月的总天数
        if (start3MonthDay < day) {
          //3个月前所在月的总天数小于现在的天日期
          dateObj.start =
            year -
            1 +
            "-" +
            this.fullzero(12 - (3 - month)) +
            "-" +
            this.fullzero(start3MonthDay);
        } else {
          dateObj.start =
            year -
            1 +
            "-" +
            this.fullzero(12 - (3 - month)) +
            "-" +
            this.fullzero(day);
        }
      } else {
        var start3MonthDay = new Date(year, parseInt(month) - 3, 0).getDate(); //3个月前所在月的总天数
        if (start3MonthDay < day) {
          //3个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数,2月份比较特殊的月份
            dateObj.start =
              year +
              "-" +
              this.fullzero(month - 3) +
              "-" +
              this.fullzero(start3MonthDay - (endMonthDay - day));
          } else {
            dateObj.start =
              year +
              "-" +
              this.fullzero(month - 3) +
              "-" +
              this.fullzero(start3MonthDay);
          }
        } else {
          dateObj.start =
            year + "-" + this.fullzero(month - 3) + "-" + this.fullzero(day);
        }
      }

      return [dateObj.start, dateObj.end];
    },
    fullzero(number) {
      return number > 9 ? number : "0" + number;
    },
    pageChange(params) {
      this.currPageNum = params.currPage;
      this.pageRange = params.range;
    }
  },
  computed: {
    tableData: {
      get() {
          let res = this.mateTableData.slice(
            (this.currPageNum - 1) * this.pageRange,
            this.currPageNum * this.pageRange
          );
          return res;
      },
      set(val) {}
    }
  }
};
</script>

<style lang="less" scoped>
.containt {
  width: 100%;
  background: #fff;
  .filt-wrapper {
    padding: 0 18px;
    .filt-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      height: 43px;
      padding-top: 16px;
      .main-title {
        font-size: 16px;
        font-weight: 700;
        height: 24px;
        line-height: 24px;
        margin-right: 20px;
      }

      .desc-title {
        height: 24px;
        line-height: 24px;
        flex-shrink: 0;
        color: #999;
        font-size: 12px;
        letter-spacing: 0;
        padding-right: 8px;
      }
      .search-box {
        display: flex;
        align-items: center;
        margin-right: 124px;
        border-bottom: 1px solid var(--strong-border-color);
        .i {
          font-size: 14px;
          color: var(--input-color);
        }
        input {
          width: 178px;
          margin: 2px;
          height: 22px;
          font-size: 12px;
          color: #212121;
          outline: 0;
          border-radius: 0;
          border: none;
          flex-grow: 1;
          background-color: transparent;
        }
        &:hover {
          border-bottom: 1px solid #5e80eb;
          i.kdfont {
            color: #5e80eb !important;
          }
        }
      }
      .togle-btn {
        display: flex;
        align-items: center;
        align-self: flex-end;
        height: 41px;
        line-height: 28px;
        padding-left: 8px;
        border-radius: 2px 2px 0 0;
        position: absolute;
        bottom: -9px;
        right: 0;
        top: 12;
        font-size: 12px;
        color: #5e80eb;
        cursor: pointer;
        .kdfont {
          transition: all 0.3s;
        }
      }
      .filt-status {
        display: flex;
        flex: 1;
        .filt-item {
          display: flex;
          padding: 0 8px;
          height: 24px;
          line-height: 22px;
          font-size: 12px;
          color: #666;
          letter-spacing: 0;
          margin-right: 6px;
          align-items: center;
          border-radius: 2px;
          border: 1px solid #ddd;
          .kdfont {
            font-size: 12px;
          }
        }
      }
    }
    .tool-bar {
      height: 45px;
      display: flex;
      align-items: center;
      .i-btn {
        margin-right: 12px;
      }
    }
    .filt-board {
      margin-top: 8px;
      padding: 0 20px;
      background-color: var(--contain-bg);
      border: 1px solid #d9d9d9;
      border-radius: 2px 0 2px 2px;
      .board-title {
        cursor: pointer;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        color: var(--third-text-color);
      }
      .filt-list {
        .filt-item {
          width: 100%;
        }
      }
    }
    &.activeted {
      .togle-btn {
        border: 1px solid #c9d7fa;
        background-color: var(--contain-bg);
        border-bottom: none;
        cursor: pointer;
        .kdfont::before {
          transform: rotate(180deg);
        }
      }
    }
  }
  .table-box {
    background: rgb(226, 231, 239);
    padding: 10px;
    .tips-bar {
      height: 32px;
      line-height: 32px;
      background: #fff;
      padding: 0 8px;
      .select-status {
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .slect-ed {
          color: #999;
        }
        .select-all-text {
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .tg_table {
      width: 100%;
    }
  }
}

.my-head {
  width: 33px;
  border-left: 1px solid #d9d9d9;
  text-align: center;
  .el-dropdown {
    margin: 0;
  }

  .i-icon {
    font-size: 16px;
    cursor: pointer;
  }
}

.filt-board.fade-enter-active,
.filt-board.fade-leave-active {
  transition: opacity 0;
}
.filt-board.fade-enter,
.filt-board.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="less">
.search-box {
  margin-right: 47px;
  .el-input.el-input--prefix {
    .el-input__inner {
      width: 200px;
      height: 27px;
      border: none;
      border-bottom: 1px solid var(--strong-border-color);
      border-radius: 0;
      font-size: 12px;
      color: var(--input-color);
    }
    .el-input__icon {
      margin-top: -5px;
      font-size: 14px;
      color: var(--input-color);
    }
  }
}

.el-dropdown {
  margin-left: 0;
  margin-right: 10px;
  .el-button-group {
    display: flex;
    .el-button {
      border: none;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2px;
      font-size: 12px;
      &.el-button--primary {
        background: #5e80eb;
        padding-top: 0;
        padding-bottom: 0;
        &:hover {
          background: #87adff;
        }
      }
    }
  }
}

.el-table {
  tr.tg-tbale-head {
    color: #333;
    background-color: #f4f4f4;
    font-size: 12px;
    font-weight: 100;
  }

  th {
    .el-table__cell {
      background-color: #f4f4f4;
    }
  }

  // td {
  //   height: 40px !important;
  // }

  .el-table__header-wrapper,
  .el-table__body-wrapper {
    .el-table__cell {
      border-left: none;
      border-right: none;
    }
  }

  .el-table__body-wrapper {
    height: calc(100% - 44px) !important;
  }

  .el-table__header-wrapper {
    .cell:hover {
      border-right: 1px solid #d9d9d9;
    }
  }
}
.el-table .el-table__cell {
  padding: 0;
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  color: #333;
  font-family: Roboto, "San Francisco", "Helvetica Neue", Helvetica, Arial,
    "PingFang SC", "Hiragina Sans GB", "WenQuanYi Micro Hei",
    "microsoft yahei ui", "microsoft yahei", sans-serif;
}

.golink_tag {
  cursor: pointer;
  color: var(--link-color);
}

.el-dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: #fff;
  color: #666;
  font-size: 12px;
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  transform: translateY(-5px);
  .el-dropdown-menu__item {
    .el-checkbox {
      .el-checkbox__label {
        font-size: 12px;
        color: #333;
        font-family: Roboto, "San Francisco", "Helvetica Neue", Helvetica, Arial,
          "PingFang SC", "Hiragina Sans GB", "WenQuanYi Micro Hei",
          "microsoft yahei ui", "microsoft yahei", sans-serif;
      }
      &.is-checked {
        .el-checkbox__label {
          color: #409eff;
        }
      }
    }
  }
}

.dropdown-item {
  line-height: 30px;
  // border-bottom: 1px solid #e5e5e5;
  margin: 0 8px;
  text-align: left;
  padding: 0 12px;
  align-items: center;
  cursor: pointer;
}

.el-table__expand-icon {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  margin-right: 0px !important;
  width: 0px !important;
  .el-icon-arrow-right {
    font-family: kdfont !important;
    &::before {
      content: "\ecb9" !important;
      position: absolute;
      top: 4px;
      left: -16px;
    }
  }
}

.el-table__expand-icon--expanded {
  width: 0px;
  .el-icon-arrow-right::before {
    content: "\ecb8" !important;
  }
}

.el-table .cell {
  position: relative !important;
  padding-left: 15px !important;
  .el-table__placeholder {
    width: 0px;
  }
}

.popper__arrow {
  display: none !important;
}

.down {
  width: 96px;
  height: 28px;
  line-height: 28px;
  position: relative;
  padding: 0;
  display: flex;
  .main-span {
    width: 72px;
  }
  .down-icon {
    width: 24px;
    height: 28px;
    margin-right: -1px;
    // background-color: #4468c2;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 0 2px 2px 0;
    font-size: 12px;
    line-height: 28px;
    &::before {
      display: block;
      transition: all 0.3s;
    }
    &.activeted::before {
      transform: rotate(0);
    }
  }
  .down-list {
    width: 60px;
    position: absolute;
    top: 28px;
    left: -1px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    margin-top: 5px;
    .down-list-item {
      height: 28px;
      line-height: 28px;
      margin: 2px 0;
      background: #fff;
      color: #666;
      font-size: 12px;
      cursor: pointer;
    }
  }
}

.down-list.fade-enter-active,
.down-list.fade-leave-active {
  transition: all 0.3s;
}
.down-list.fade-enter,
.down-list.fade-leave-to {
  opacity: 0;
  height: 0;
}
</style>

<style>
.el-table th.el-table__cell > .cell {
  color: #333;
  font-size: 12px;
  font-weight: normal;
}

.i-btn {
  width: 60px;
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 28px;
  line-height: 24px;
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  outline: 0;
  white-space: nowrap;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.i-btn.sure {
  border: 1px solid var(--theme-color);
  color: #fff;
  background-color: var(--theme-color);
}

.i-btn.sure:hover {
  background-color: var(--theme-color-level5);
  border-color: var(--theme-color-level5);
}

.i-btn.view-log {
  min-width: 88px;
  max-width: 240px;
}

.el-table__fixed,
.el-table__fixed-right {
  height: 100%;
  box-shadow: none;
}
</style>